import { isFeatureEnabled } from 'owa-feature-flags';
import { SharingLinkInfo } from 'owa-link-data';

import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export function canDownloadLink(sharingLinkInfo: SharingLinkInfo): boolean {
    const classicAttachmentsEnabled: boolean = getUserConfiguration().AttachmentPolicy
        .ClassicAttachmentsEnabled;
    if (
        !isFeatureEnabled('doc-attachment-contextualSharingTips') ||
        !classicAttachmentsEnabled ||
        sharingLinkInfo.sharingInfo.blocksDownload
    ) {
        return false;
    }

    // We cannot download OneNotes or folders
    const mimeType: string = sharingLinkInfo.mimeType;
    if (mimeType && (mimeType === 'application/onenote' || mimeType === 'text/directory')) {
        return false;
    }

    if (sharingLinkInfo.sharingInfo && sharingLinkInfo.sharingInfo.blocksDownload) {
        return false;
    }

    return true;
}
